import { render, staticRenderFns } from "./PriceFiltersList.vue?vue&type=template&id=a7bcd66a&scoped=true&"
import script from "./PriceFiltersList.vue?vue&type=script&lang=js&"
export * from "./PriceFiltersList.vue?vue&type=script&lang=js&"
import style0 from "./PriceFiltersList.vue?vue&type=style&index=0&id=a7bcd66a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7bcd66a",
  null
  
)

export default component.exports